import React, { useEffect, useMemo, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import SearchBar from "./../../../component/atoms/input/searchBar";
// import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import EventBtn from "../../../component/atoms/button/eventBtn";
import Pagination from "./../../../component/molecules/pagination";
import { route } from "./../../../router/route";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import Td from "./../../../component/atoms/layout/table/td";
import moment from "moment";
import { errorHandler } from "../../../util/errorHandler";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import TableFilter from "./../../../component/atoms/layout/table/tableFilter";
import RedBtn from "../../../component/atoms/button/redBtn";
import BlueBtn from "./../../../component/atoms/button/blueBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import Modal from "../../../component/templates/Modal";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import MainInput from "./../../../component/atoms/input/mainInput";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import CategoryApi from "../../../api/category.api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ProductApi from "../../../api/product.api";
import { useRecoilState } from "recoil";
import {
  initialProductManagementState,
  productManagementState,
} from "../../../store/productState";
import { fileUrl, homepage } from "../../../api/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { minToMs } from "../../../util/formatMs";
import Loading from "../../../component/templates/Loading";

const ShoppingProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const queryClient = useQueryClient();

  // ========== 쓰기 권한체크 ========== //
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.shopping_product)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ========== 마운트가 되면 ========== //
  useEffect(() => {
    setProductManagementValue(initialProductManagementState);
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");

    const lastMerchContentTypeId = sessionStorage.getItem(
      "lastMerchContentTypeId"
    );

    if (lastMerchContentTypeId) {
      setSelectedMainCategory(Number(lastMerchContentTypeId));
      getProductList(Number(lastMerchContentTypeId));
    } else {
      getProductList(1);
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");

  // ========== 팝업 관련 ========== //
  const [popupOpen, setPopupOpen] = useState(false);

  // ========== 상품 추가 입력값 관련 ========== //
  const [, setProductManagementValue] = useRecoilState(productManagementState);

  // ========== 메인 카테고리 관련 ========== //
  const [selectedMainCategory, setSelectedMainCategory] = useState(1);
  const [selectedPopupMainCategory, setSelectedPopupMainCategory] = useState({
    id: 0,
    title: "",
    activation: true,
  });
  const [activationStatus, setActivationStatus] = useState(true);

  const resetSelectedPopupMainCategory = () => {
    setSelectedPopupMainCategory({
      id: 0,
      title: "",
      activation: true,
    });
  };

  useEffect(() => {
    resetSelectedPopupMainCategory();
    setActivationStatus(true);
  }, [popupOpen]);

  useEffect(() => {
    setActivationStatus(true);
  }, [selectedPopupMainCategory]);

  // 메인 카테고리 리스트 가져오기
  const getMainCategoryList = async () => {
    const data = {
      page: 1,
      size: 0,
      sort: "orderNumber",
      orderBy: "ASC",
    };

    const response = (await CategoryApi.getListMain(data)).data.data.content;

    return response || [];
  };

  const {
    data: mainCategoryList = [],
    isLoading: isMainCategoryListLoading,
    isError: isMainCategoryListError,
  } = useQuery({
    queryKey: ["mainCategoryList", pathName],
    queryFn: getMainCategoryList,
    onError: (error) => {
      errorHandler(error);
    },
    staleTime: minToMs(15),
  });

  // 메인 카테고리 드래그 앤 드롭
  const { mutate: updateCategoryOrder } = useMutation({
    mutationFn: async (updatedList) => {
      const data = { merchMainCategoryList: updatedList };
      return await CategoryApi.updateMain(data);
    },
    onSuccess: () => {
      resetSelectedPopupMainCategory();
      queryClient.invalidateQueries(["mainCategoryList", pathName]);
    },
    onError: (error) => errorHandler(error),
  });

  const handleDragAndDrop = (result) => {
    const { destination, source } = result;

    if (!destination) return; // 드래그가 취소된 경우

    const updatedList = Array.from(mainCategoryList); // 기존 배열을 복사

    // 드래그된 요소를 배열에서 제거하고 새로운 위치에 삽입
    const [reorderedItem] = updatedList.splice(source.index, 1);
    updatedList.splice(destination.index, 0, reorderedItem);

    updateCategoryOrder(updatedList); // API 요청 실행
  };

  // 메인 카테고리 추가하기
  const { mutate: createMainCategory } = useMutation({
    mutationFn: async (newCategory) => {
      return await CategoryApi.createMain(newCategory);
    },
    onSuccess: () => {
      toast(toastMsg.create);
      resetSelectedPopupMainCategory();
      queryClient.invalidateQueries(["mainCategoryList", pathName]);
    },
    onError: (error) => errorHandler(error),
  });

  const addMainCategoryHandler = async () => {
    if (!selectedPopupMainCategory.title) {
      toast("카테고리명을 입력해주세요.");
      return;
    }

    const data = {
      title: selectedPopupMainCategory.title,
      activation: activationStatus,
    };

    createMainCategory(data);
  };

  // 메인 카테고리 수정하기
  const { mutate: updateMainCategory } = useMutation({
    mutationFn: async (updatedCategory) => {
      return await CategoryApi.updateMain(updatedCategory);
    },
    onSuccess: () => {
      toast(toastMsg.update);
      resetSelectedPopupMainCategory();
      queryClient.invalidateQueries(["mainCategoryList", pathName]);
    },
    onError: (error) => errorHandler(error),
  });

  const editCategoryHandler = () => {
    if (selectedPopupMainCategory.title === "") {
      toast("카테고리명을 입력해주세요.");
      return;
    }

    const updatedList = mainCategoryList.map((category) =>
      category.id === selectedPopupMainCategory.id
        ? {
            id: selectedPopupMainCategory.id,
            title: selectedPopupMainCategory.title,
            activation: selectedPopupMainCategory.activation,
          }
        : category
    );

    const data = {
      merchMainCategoryList: updatedList,
    };

    updateMainCategory(data);
  };

  // 메인 카테고리 삭제하기
  const [mainCategoryDeleteModalOpen, setMainCategoryDeleteModalOpen] =
    useState(false);

  const { mutate: deleteMainCategory } = useMutation({
    mutationFn: async (deleteId) => {
      return await CategoryApi.deleteMain(deleteId);
    },
    onSuccess: () => {
      toast(toastMsg.delete);
      setMainCategoryDeleteModalOpen(false);
      resetSelectedPopupMainCategory();
      queryClient.invalidateQueries(["mainCategoryList", pathName]);
    },
    onError: (error) => errorHandler(error),
  });

  // ========== 페이지네이션 관련 ========== //
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ========== 상품 관련 ========== //
  // 상품 리스트 관련 상태
  const [productList, setProductList] = useState([]);

  // 상품 리스트 가져오기
  const getProductList = async (productId) => {
    try {
      const data = {
        page: page,
        size: pagination.size,
        saveStatus: "Y",
        sort: "orderNumber",
        merchType: "SHOP",
      };

      if (keyword) {
        data.keyword = keyword;
      }

      if (productId) {
        data.merchMainCategoryId = productId;
      }

      const response = (await ProductApi.getListProduct(data)).data.data;

      const processedData = response.content.map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
          checked: false,
          imageIsValid: true,
        };
      });

      const processedDataWithImages = await Promise.all(
        processedData.map(
          (item) =>
            new Promise((resolve) => {
              if (item.thumbnailServerFileName) {
                const img = new Image();
                img.src = `${fileUrl}/${item.thumbnailServerFileName}`;

                img.onload = () => {
                  resolve({ ...item, imageIsValid: true });
                };

                img.onerror = () => {
                  resolve({ ...item, imageIsValid: false });
                };
              } else {
                resolve(item);
              }
            })
        )
      );

      setProductList(processedDataWithImages);

      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: response.totalPage || Math.ceil(response.totalCount / 10),
        first: response.first,
        last: response.last,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ========== 체크 관련 ========== //
  const [checkedList, setCheckedList] = useState([]);

  const isAllCheck = useMemo(() => {
    const checkedList = productList.filter((item) => item.checked);
    return (
      checkedList.length !== 0 && checkedList.length === productList.length
    );
  }, [productList]);

  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);

  useEffect(() => {
    const checkedList = productList.filter((item) => item.checked);
    if (checkedList.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }

    setCheckedList(checkedList);
  }, [productList]);

  const [deleteId, setDeleteId] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      await ProductApi.deleteProduct(deleteId);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      getProductList(selectedMainCategory);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ========== 상품 복제 ========== //
  const replicationProduct = async () => {
    try {
      const response = (await ProductApi.getByIdProduct(checkedList[0].id)).data
        .data.content;

      const data = {
        merchMainCategoryId: response.merchMainCategory.id,
        merchSubCategoryId: response.merchSubCategory.id,
        title: response.title,
        writer: response.writer,
        price: response.price,
        isPreviewEnabled: response.isPreviewEnabled,
        isFreeTrial: response.isFreeTrial,
        isComingSoon: response.isComingSoon,
        isNonSale: response.isNonSale,
        isMembershipOnly: response.isMembershipOnly,
        intro: response.intro,
        content: response.content,
        thumbnailOriginFileName: response.thumbnailOriginFileName,
        thumbnailServerFileName: response.thumbnailServerFileName,
        bannerOriginFileName: response.bannerOriginFileName,
        bannerServerFileName: response.bannerServerFileName,
        relatedMerchUse: response.relatedMerchUse,
        openAlarmUse: response.openAlarmUse,
        merchType: "SHOP",
      };

      const createResponse = (await ProductApi.createProduct(data)).data.data;
      await ProductApi.uploadProduct(createResponse.id);
      getProductList(selectedMainCategory);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ========== 순서 변경 ========== //
  const orderEdit = async (id, order, keyword) => {
    try {
      const data = {
        orderDirection: order,
        merchSearchDto: {
          saveStatus: "Y",
          merchType: "SHOP",
        },
      };

      if (selectedMainCategory) {
        data.merchSearchDto.merchMainCategoryId = selectedMainCategory;
      }

      if (keyword) {
        data.merchSearchDto.keyword = keyword;
      }

      await ProductApi.updateOrderProduct(id, data);

      getProductList(selectedMainCategory);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ========== 판매 상태 관련 ========== //
  const [filterOpen, setFilterOpen] = useState(-1);
  const [saleStatusId, setSaleStatusId] = useState(null);
  const [saleStatus, setSaleStatus] = useState(null);
  const [saleStatusModalTitle, setSaleStatusModalTitle] = useState("");
  const [saleStatusModalOpen, setSaleStatusModalOpen] = useState(false);

  const activationFunc = async () => {
    try {
      const data = {
        activation: saleStatus,
      };
      await ProductApi.updateActivationProduct(saleStatusId, data);
      toast(toastMsg.create);
      setFilterOpen(-1);
      setSaleStatusModalOpen(false);
      getProductList(selectedMainCategory);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="카테고리">
          {isMainCategoryListLoading || isMainCategoryListError ? (
            <div
              style={{
                width: "100%",
                height: 39,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loading color="#3a96df" style={{ position: "static" }} />
            </div>
          ) : (
            <>
              {/* <SubSideBarItem
            selected={selectedMainCategory === ""}
            onClick={() => {
              setSelectedMainCategory("");
              getProductList();
            }}
          >
            전체
          </SubSideBarItem> */}
              {mainCategoryList.map((item, index) => {
                return (
                  <SubSideBarItem
                    key={index}
                    onClick={() => {
                      setSelectedMainCategory(item.id);
                      getProductList(item.id);

                      sessionStorage.setItem("lastMerchContentTypeId", item.id);
                    }}
                    selected={selectedMainCategory === item.id}
                  >
                    {item.title}
                  </SubSideBarItem>
                );
              })}
            </>
          )}
          <SubSideBarFooter>
            <SubSideBarFooterText>카테고리 관리</SubSideBarFooterText>
            <img
              src="/assets/admin/icons/ico_setting.svg"
              style={{
                width: 13,
                height: 13,
                cursor: "pointer",
              }}
              onClick={() => {
                if (isWriteAuthority) {
                  setPopupOpen(true);
                } else {
                  toast(
                    <>
                      편집 권한이 없습니다.
                      <br />
                      최고관리자에게 문의하세요.
                    </>
                  );
                }
              }}
              alt="카테고리 관리"
            />
          </SubSideBarFooter>
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>상품관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"상품"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"상품명"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    if (keyword !== "") {
                      navigate(
                        `${route.shopping_product}?page=1&keyword=${keyword}`,
                        {
                          replace: true,
                        }
                      );
                    } else {
                      navigate(route.shopping_product, {
                        replace: true,
                      });
                    }
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.shopping_product}?page=1&keyword=${keyword}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              {/* <ExcelBtn /> */}
              <EventBtn
                text={"상품 추가하기"}
                onClick={() => {
                  if (isWriteAuthority) {
                    navigate(route.shopping_product_create_basic);
                  } else {
                    toast(
                      <>
                        편집 권한이 없습니다.
                        <br />
                        최고관리자에게 문의하세요.
                      </>
                    );
                  }
                }}
              />
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              {productList.filter((item) => item.checked).length === 1 && (
                <>
                  <RedBtn
                    onClick={() => {
                      setDeleteId(
                        productList.filter((item) => item.checked)[0].id
                      );
                      setDeleteModalOpen(true);
                    }}
                  >
                    삭제
                  </RedBtn>
                  <BlueBtn
                    onClick={() => {
                      replicationProduct();
                    }}
                  >
                    복제
                  </BlueBtn>

                  <GrayBtn
                    onClick={() => {
                      const checkedList = productList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "TOP", keyword);
                    }}
                  >
                    맨 위로
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      const checkedList = productList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "UP", keyword);
                    }}
                  >
                    위로
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      const checkedList = productList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "DOWN", keyword);
                    }}
                  >
                    아래로
                  </GrayBtn>
                  <GrayBtn
                    onClick={() => {
                      const checkedList = productList.filter(
                        (item) => item.checked
                      );
                      orderEdit(checkedList[0].id, "BOTTOM", keyword);
                    }}
                  >
                    맨 아래로
                  </GrayBtn>
                </>
              )}
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="48px" />
              {/* No */}
              <col width="40px" />
              {/* 상품명 */}
              <col width="329px" />
              {/* 목차 */}
              <col width="25px" />
              {/* 판매가 */}
              <col width="123px" />
              {/* 카테고리 */}
              <col width="150px" />
              {/* 상태 */}
              <col width="111px" />
              {/* 등록일 */}
              <col width="113px" />
              {/* 수정일 */}
              <col width="105px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "16px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setProductList(
                          productList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setProductList(
                          productList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상품명
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    목차
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      textAlign: "right",
                    }}
                  >
                    판매가
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      paddingLeft: "30px",
                    }}
                  >
                    카테고리
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상태
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    등록일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    수정일
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {productList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "72px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "16px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setProductList([...productList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    <Td
                      style={{
                        display: "flex",
                        height: "72px",
                        alignItems: "center",
                      }}
                    >
                      {item.thumbnailServerFileName && item.imageIsValid ? (
                        <img
                          src={`${fileUrl}/${item.thumbnailServerFileName}`}
                          alt="상품 이미지"
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "cover",
                            marginRight: "16px",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            marginRight: "16px",
                            backgroundColor: "#272829",
                          }}
                        />
                      )}
                      <TableText
                        style={{
                          cursor: "pointer",
                          maxWidth: "256px",
                          marginRight: "6px",
                        }}
                        onClick={() => {
                          if (isWriteAuthority) {
                            navigate(
                              `${route.shopping_product_edit_basic}/${item.id}`
                            );
                          } else {
                            toast(
                              <>
                                편집 권한이 없습니다.
                                <br />
                                최고관리자에게 문의하세요.
                              </>
                            );
                          }
                        }}
                      >
                        {item.title}
                      </TableText>
                      <a
                        href={`${homepage}/home/knowledgeStore/category/detail/ebook/${item.id}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src="/assets/admin/icons/ico_page.svg"
                          alt="바로가기"
                          style={{
                            width: 14,
                            height: 14,
                          }}
                        />
                      </a>
                    </Td>
                    <Td>
                      <img
                        src="/assets/admin/icons/ico_curriculum.svg"
                        alt="목차/커리큘럼"
                        style={{
                          width: 21,
                          height: 20,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate(
                            `${route.shopping_product_chapter}/${item.id}`
                          );
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          textAlign: "right",
                        }}
                      >
                        {formatNumberWithCommas(item.price)}원
                      </TableText>
                    </Td>
                    <Td style={{ paddingLeft: "30px" }}>
                      <TableText>
                        {item.merchMainCategory.title || ""}
                      </TableText>
                    </Td>
                    <Td>
                      <TableFilter
                        style={{
                          width: "fit-content",
                          gap: 10,
                        }}
                        onClick={() => {
                          if (isWriteAuthority) {
                            filterOpen === index
                              ? setFilterOpen(-1)
                              : setFilterOpen(index);
                          } else {
                            toast(
                              <>
                                편집 권한이 없습니다.
                                <br />
                                최고관리자에게 문의하세요.
                              </>
                            );
                          }
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.activation}
                        list={[
                          {
                            value: true,
                            title: "판매중",
                            onClick: () => {
                              setSaleStatusId(item.id);
                              setSaleStatus(true);
                              setSaleStatusModalTitle("판매중");
                              setSaleStatusModalOpen(true);
                            },
                          },
                          {
                            value: false,
                            title: "숨김",
                            onClick: () => {
                              setSaleStatusId(item.id);
                              setSaleStatus(false);
                              setSaleStatusModalTitle("숨김");
                              setSaleStatusModalOpen(true);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.updatedAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.shopping_product}
            queryString={
              keyword ? `keyword=${searchParams.get("keyword")}` : ""
            }
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 카테고리 관리 팝업 */}
      {popupOpen && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen(false);
          }}
        >
          <Popup
            headerTitle="카테고리 관리"
            footerBtnText="저장하기"
            onClick={() => {
              setPopupOpen(false);
            }}
            footerBtnHandler={() => {
              if (selectedPopupMainCategory.id === 0) {
                addMainCategoryHandler();
              } else {
                editCategoryHandler();
              }
            }}
          >
            <div
              style={{
                width: "fit-content",
                height: "fit-content",
                margin: "16px 30px",
                display: "flex",
              }}
            >
              <div
                style={{
                  width: "200px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DragDropContext onDragEnd={handleDragAndDrop}>
                  <Droppable droppableId="mainCategories">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {mainCategoryList.map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={String(item.id)}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <SubSideBarItem
                                  selected={
                                    selectedPopupMainCategory.id === item.id
                                  }
                                  move={true}
                                  onClick={() => {
                                    setSelectedPopupMainCategory({
                                      id: item.id,
                                      title: item.title,
                                      activation: item.activation,
                                    });
                                  }}
                                >
                                  {item.title}
                                </SubSideBarItem>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                <SubSideBarItem
                  icon="plus"
                  selected={selectedPopupMainCategory.id === 0}
                  onClick={() => {
                    setSelectedPopupMainCategory({
                      id: 0,
                      title: "",
                      activation: true,
                    });
                  }}
                  plusHandler={() => {
                    setSelectedPopupMainCategory({
                      id: 0,
                      title: "",
                      activation: true,
                    });
                  }}
                >
                  새 카테고리 추가하기
                </SubSideBarItem>
              </div>
              <span
                style={{
                  width: "1px",
                  height: "399px",
                  marginLeft: "14px",
                  marginRight: "20px",
                  backgroundColor: " rgba(255, 255, 255, 0.12)",
                }}
              />
              <div
                style={{
                  width: "338px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "3px",
                  }}
                >
                  <PretendardText
                    style={{
                      fontSize: "15px",
                      fontWeight: "400",
                      lineHeight: "22px",
                      color: "#aaa",
                    }}
                  >
                    카테고리명
                  </PretendardText>
                  <MainInput
                    type={"text"}
                    placeholder={"카테고리명을 입력해 주세요."}
                    style={{ width: "338px" }}
                    value={selectedPopupMainCategory.title}
                    disabled={
                      selectedPopupMainCategory.id > 0 &&
                      selectedPopupMainCategory.id < 6
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      setSelectedPopupMainCategory({
                        ...selectedPopupMainCategory,
                        title: e.target.value,
                      });
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: "10px",
                  }}
                  onClick={() => {}}
                >
                  <Checkbox
                    checked={
                      selectedPopupMainCategory.id === 0
                        ? !activationStatus
                        : !selectedPopupMainCategory.activation
                    }
                    onChange={() => {
                      if (selectedPopupMainCategory.id === 0) {
                        setActivationStatus(!activationStatus);
                      } else {
                        setSelectedPopupMainCategory({
                          ...selectedPopupMainCategory,
                          activation: !selectedPopupMainCategory.activation,
                        });
                      }
                    }}
                  />
                  <PretendardText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    홈페이지에 노출하지 않기
                  </PretendardText>
                </div>
                <PretendardText
                  style={{
                    fontSize: "15px",
                    fontWeight: "500",
                    lineHeight: "21.5px",
                    color: "var(--text3, rgba(181, 181, 181, 0.5))",
                    marginTop: "5px",
                  }}
                >
                  고객들이 보는 페이지에 목록이 노출되지 않습니다
                </PretendardText>
                <div
                  style={{
                    marginTop: 247,
                    width: "100%",
                    height: 22,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {selectedPopupMainCategory.id !== 0 &&
                    selectedPopupMainCategory.id > 5 && (
                      <PretendardText
                        style={{
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "21.5px",
                          color: "rgba(181, 181, 181, 0.5)",
                          marginTop: "5px",
                          cursor: "pointer",
                          textDecorationLine: "underline",
                        }}
                        onClick={() => {
                          setMainCategoryDeleteModalOpen(true);
                        }}
                      >
                        삭제하기
                      </PretendardText>
                    )}
                </div>
              </div>
            </div>
            <ul
              style={{
                position: "absolute",
                left: 30,
                bottom: 50,
                listStyle: "disc",
                listStylePosition: "inside",
                listColor: "#aaa",
                marginRight: 0,
              }}
            >
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "15px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  color: "var(--text3, rgba(181, 181, 181, 0.5))",
                }}
              >
                마우스 드래그로 카테고리 순서를 조정해보세요
              </li>
            </ul>
          </Popup>
        </PopupOverLay>
      )}

      {/* 메인 카테고리 삭제하기 모달 */}
      {mainCategoryDeleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setMainCategoryDeleteModalOpen}
          onClick={() => {
            deleteMainCategory(selectedPopupMainCategory.id);
          }}
        />
      )}

      {/* 상품 삭제하기 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}

      {/* 판매 상태 변경 모달 */}
      {saleStatusModalOpen ? (
        <Modal
          title={`${saleStatusModalTitle} 하시겠습니까?`}
          setModalOpen={setSaleStatusModalOpen}
          onClick={() => {
            activationFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default ShoppingProduct;

const SubSideBarFooter = styled.div.attrs((props) => {})`
  margin-top: 5px;
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0px 16px;
  border-top: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const SubSideBarFooterText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;
